/* eslint-disable-next-line  no-unused-vars */
import { createElement, useContext, useRef } from 'react';
import React, { useEffect, useState } from 'react';
import './Action.scss';
import { Divider, IconButton, Menu } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { MapContext } from '../map/MapContextProvider';
import MeasureMenu from '../measure/MeasureMenu';
import ActionContextProvider from './ActionContextProvider';

/*global google*/
export default function ActionComponent({ measureEnabled, children }) {
    const { map } = useContext(MapContext);
    const actionRef = useRef();

    const [actionLabel, setActionLabel] = useState('Actions');
    const [action, setAction] = useState();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    useEffect(() => {
        if (map) {
            map.controls[google.maps.ControlPosition.RIGHT_TOP].clear();
            map.controls[google.maps.ControlPosition.TOP_RIGHT].clear();
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(actionRef.current);
        }
    }, [map]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const setActionHandle = (actEnum) => {
        setActionLabel(actEnum.label);
        setAction(actEnum.action);
        setAnchorEl(null);
    };

    return (
        <>
            <ActionContextProvider action={action} setAction={setActionHandle}>
                {children ? children : <></>}
            </ActionContextProvider>

            <div className="overlay-action" ref={actionRef}>
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon /> {actionLabel}
                </IconButton>

                <Menu anchorEl={anchorEl} open={open} onClose={handleClose} id="long-menu">
                    {measureEnabled && <MeasureMenu setAction={setActionHandle} />}
                </Menu>
            </div>
        </>
    );
}
